import React from 'react';

const DeleteBtn = ({ deleting, confirmDelete, id, handleDelete, onClick }) => {
	if (deleting && confirmDelete === id) {
		return <div className="loading" />;
	}
	if (confirmDelete === id) {
		return (
			<button
				type="button"
				className="btn btn-danger btn-sm"
				onClick={handleDelete}
			>
				Confirmar
			</button>
		);
	}
	return (
		<button
			type="button"
			className="btn btn-outline-danger btn-sm"
			id={id}
			onClick={onClick}
		>
			Borrar
		</button>
	);
};

export default DeleteBtn;



// WEBPACK FOOTER //
// ./src/helpers/DeleteBtn.js